var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titles',{attrs:{"title":"投资吸引力"}}),_c('div',{style:({width: '820px', height: '500px'}),attrs:{"id":"myChart6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }